import { createContext } from 'react';

export interface DisplayModeContextType {
  displayMode: 'compact' | 'expanded';
  isAnimating: boolean;
  setDisplayMode: (displayMode: 'compact' | 'expanded') => void;
  setIsAnimating: (isAnimating: boolean) => void;
}

export const DisplayModeContext = createContext<DisplayModeContextType>({
  displayMode: 'expanded',
  isAnimating: false,
  setDisplayMode: () => {},
  setIsAnimating: () => {},
});
